export default __webpack_public_path__ + "static/media/signup-graphic.52fc5812.png";